import { apiClient } from '../utils/apiClient';
import type { CCompareResponse } from '@arrowise/shared';

class CompareService {
    async getCompareData(positionId: string, order: 'best' | 'worst' = 'best'): Promise<CCompareResponse> {
        const response = await apiClient.get<CCompareResponse>(`/positions/${positionId}/compare?order=${order}`);
        if (!response.success || !response.data) throw new Error(response.message || 'Failed to load compare data');
        return response.data;
    }
}

export const compareService = new CompareService();
export default compareService;
